import { Tile3DLayer } from "deck.gl";


const GOOGLEMAP_API_KEY = "AIzaSyA8X-e3Naz_Pu50cP8bdDQUZukKrXMqDGs"

export function renderLayers(props) {
 
  const tile3Dlayer = new Tile3DLayer({
    id: 'tile-3d-layer',
    // Tileset entry point: Indexed 3D layer file url
    data: `https://tile.googleapis.com/v1/3dtiles/root.json?key=${GOOGLEMAP_API_KEY}`,
    loadOptions: {
      tileset: {
        throttleRequests: false,
      },
      fetch: { headers: { 'X-GOOG-API-KEY': GOOGLEMAP_API_KEY } }
    },
    onTilesetLoad: tileset3d => {
      tileset3d.options.onTraversalComplete = selectedTiles => {
        const credits = new Set();
        selectedTiles.forEach(tile => {
          const { copyright } = tile.content.gltf.asset;
          copyright.split(';').forEach(credits.add, credits);
          document.querySelector("#copyright").innerHTML = [...credits].join('; ');
        });
        return selectedTiles;
      }
    },
    _subLayerProps: {
      scenegraph: { _lighting: 'pbr' }
    },
    operation: 'terrain+draw'
  });


  return [tile3Dlayer];
}
